import { Injectable } from '@angular/core';
import { ToastActionKind, ToastConfig, ToastRef, resolveToastDuration } from '@gh/core-ui';
import { EMPTY$, of$ } from '@gh/rx';
import { delay$, switchMap$, takeUntil$ } from '@gh/rx/operators';
import { get, without } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { DefaultToastRef, ToastItem, ToastStatus } from './toast-item';

@Injectable()
export class ToastContext extends BehaviorSubject<ToastItem[]> {
  constructor() {
    super([]);
  }

  create(config: ToastConfig): ToastRef {
    const item = new ToastItem(config);
    this.next([item].concat(this.value));

    const durationMs = resolveToastDuration(config);
    if (durationMs) {
      const statusMap = {
        [ToastStatus.Free]: of$(ToastStatus.Closed).pipe(delay$(durationMs)),
      };
      item.status.pipe(
        switchMap$((status: ToastStatus) => get(statusMap, status, EMPTY$)),
        takeUntil$(item.afterClosed),
      ).subscribe(() => item.close());
    }

    item.afterClosed.subscribe(() => this.next(without(this.value, item)));
    return new DefaultToastRef(item);
  }

  closeAll(): void {
    this.value.forEach((item) => item.close());
  }

  hasUndoEligible(): boolean {
    return this.value.some((item) => item.config.action && item.config.action.kind === ToastActionKind.Undo);
  }

  undoTop(): boolean {
    const item = this.value.find((candidate) =>
      candidate.config.action && candidate.config.action.kind === ToastActionKind.Undo);
    if (!item || !item.config.action) {
      return false;
    }
    item.config.action.run();
    return true;
  }
}
